/**
 * @generated SignedSource<<45aa67561ad8fcecaab12f4b61c5d6b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SavingsPlanFrequency = "BIWEEKLY" | "DAILY" | "MONTHLY" | "WEEKLY";
export type SavingsPlanStatus = "ACTIVE" | "CANCELED";
export type AcceptSavingsPlanInput = {
  id: string;
};
export type AcceptSavingsPlanMutation$variables = {
  input?: AcceptSavingsPlanInput | null | undefined;
};
export type AcceptSavingsPlanMutation$data = {
  readonly acceptSavingsPlan: {
    readonly asset: {
      readonly id: string;
      readonly logoUrl: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly day: number | null | undefined;
    readonly fiat: {
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly fiatAmount: PrecisionFloat | null | undefined;
    readonly frequency: SavingsPlanFrequency | null | undefined;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly nextRecurrence: TimeScalar | null | undefined;
    readonly notificationDate: TimeScalar | null | undefined;
    readonly status: SavingsPlanStatus | null | undefined;
  } | null | undefined;
};
export type AcceptSavingsPlanMutation = {
  response: AcceptSavingsPlanMutation$data;
  variables: AcceptSavingsPlanMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextRecurrence",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationDate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frequency",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptSavingsPlanMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SavingsPlan",
        "kind": "LinkedField",
        "name": "acceptSavingsPlan",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Fiat",
            "kind": "LinkedField",
            "name": "fiat",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "asset",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptSavingsPlanMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SavingsPlan",
        "kind": "LinkedField",
        "name": "acceptSavingsPlan",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Fiat",
            "kind": "LinkedField",
            "name": "fiat",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "asset",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "57bbd2dcd55a5b3b7a24239d4d9dbc4e",
    "id": null,
    "metadata": {},
    "name": "AcceptSavingsPlanMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptSavingsPlanMutation(\n  $input: AcceptSavingsPlanInput\n) {\n  acceptSavingsPlan(input: $input) {\n    id\n    day\n    name\n    nextRecurrence\n    notificationDate\n    fiat {\n      name\n      id\n    }\n    asset {\n      __typename\n      id\n      name\n      logoUrl\n    }\n    fiatAmount\n    frequency\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "93df2bdc2d59019a2c52697e3995ca7f";

export default node;
